// extracted by mini-css-extract-plugin
module.exports = {"rule":"_2ugMI1E18_BR_ct-JhaRBK"};